import { Dispatch, SetStateAction, forwardRef } from 'react';

import { Icon, ListItem } from 'coreOld/elements';
import { getDisplayName } from 'coreOld/utils';
import { ITab } from 'coreOld/types';

import { Container, MenuTitle, MenuWrapper, NavWrapper, ToggleButton } from './tabNavigationStyle';

interface IProps {
  tabs: ITab[];
  activeTab: ITab;
  setActiveTab: Dispatch<SetStateAction<ITab>>;
  height: number | undefined;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const TabsNavigationView = forwardRef((props: IProps, ref) => {
  const { tabs, activeTab, setActiveTab, height, setIsOpen } = props;

  return (
    <NavWrapper>
      <ToggleButton onClick={() => setIsOpen((prev) => !prev)}>
        <Icon name={Icon.BARS} />
        <MenuTitle>Sub Tab Nav</MenuTitle>
      </ToggleButton>

      <MenuWrapper style={{ height }}>
        <Container ref={ref}>
          {tabs.map((tab, index) => (
            <ListItem
              key={index}
              icon={tab.icon}
              title={tab.title}
              selected={tab.title === activeTab?.title}
              onClick={() => setActiveTab(tab)}
            />
          ))}
        </Container>
      </MenuWrapper>
    </NavWrapper>
  );
});

TabsNavigationView.displayName = `TabsNavigationView(${getDisplayName(TabsNavigationView)})`;

export default TabsNavigationView;
